// userReducer.js

import {
  FETCH_PROMPTS_FAILURE,
  FETCH_PROMPTS_REQUEST,
  FETCH_PROMPTS_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  UPDATE_PROMPT_FAILURE,
  UPDATE_PROMPT_REQUEST,
  UPDATE_PROMPT_SUCCESS,
  FETCH_APP_PREFERENCES_REQUEST,
  FETCH_APP_PREFERENCES_SUCCESS,
  FETCH_APP_PREFERENCES_FAILURE,
  UPDATE_APP_PREFERENCES_REQUEST,
  UPDATE_APP_PREFERENCES_SUCCESS,
  UPDATE_APP_PREFERENCES_FAILURE,
  UPDATE_COUNTRY_PREFERENCE,
  UPDATE_JURISDICTION_PREFERENCE,
  SET_JURISDICTION_TREE,
  SET_SEARCH_MODE,
} from "../actions/types";

const initialState = {
  organization_prompt: null,
  users: [],
  loading: false,
  error: null,
  appPreferences: {
    app_language: 'en',
    countries: []
  },
  appPreferencesLoading: false,
  appPreferencesError: null,
  countryPreference: ['MA'],
  jurisdictionPreference: {},  // { AE: null | ['AE_DUBAI', ...] } — null/absent = all
  jurisdictionTrees: {},       // { AE: { tree: [...], all_codes: [...], has_sub_jurisdictions: true } }
  searchMode: 'law',
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
      };
    case FETCH_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PROMPT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_PROMPT_SUCCESS:
      return {
        ...state,
        loading: false,
        organization_prompt: action.payload,
        error: null,
      };
    case UPDATE_PROMPT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_PROMPTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PROMPTS_SUCCESS:
      return {
        ...state,
        loading: false,
        organization_prompt: action.payload,
      };
    case FETCH_PROMPTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_APP_PREFERENCES_REQUEST:
      return {
        ...state,
        appPreferencesLoading: true,
        appPreferencesError: null,
      };
    case FETCH_APP_PREFERENCES_SUCCESS:
      return {
        ...state,
        appPreferences: action.payload,
        appPreferencesLoading: false,
      };
    case FETCH_APP_PREFERENCES_FAILURE:
      return {
        ...state,
        appPreferencesLoading: false,
        appPreferencesError: action.payload,
      };

    case UPDATE_APP_PREFERENCES_REQUEST:
      return {
        ...state,
        appPreferencesLoading: true,
        appPreferencesError: null,
      };
    case UPDATE_APP_PREFERENCES_SUCCESS:
      return {
        ...state,
        appPreferences: action.payload,
        appPreferencesLoading: false,
      };
    case UPDATE_APP_PREFERENCES_FAILURE:
      return {
        ...state,
        appPreferencesLoading: false,
        appPreferencesError: action.payload,
      };

    case UPDATE_COUNTRY_PREFERENCE: {
      const COUNTRY_CODE_MAP = { UAE: 'AE' }
      const normalize = (c) => COUNTRY_CODE_MAP[c] || c
      const raw = Array.isArray(action.payload) ? action.payload : [action.payload]
      const newCountries = raw.map(normalize)
      // Clean up jurisdiction prefs for deselected countries
      const newJurPref = { ...state.jurisdictionPreference }
      Object.keys(newJurPref).forEach(code => {
        if (!newCountries.includes(code)) delete newJurPref[code]
      })
      return {
        ...state,
        countryPreference: newCountries,
        jurisdictionPreference: newJurPref,
      };
    }

    case UPDATE_JURISDICTION_PREFERENCE: {
      const { countryCode, jurisdictionCodes } = action.payload
      const newPref = { ...state.jurisdictionPreference }
      if (jurisdictionCodes === null) {
        delete newPref[countryCode]  // null = all → remove entry
      } else {
        newPref[countryCode] = jurisdictionCodes
      }
      return { ...state, jurisdictionPreference: newPref };
    }

    case SET_JURISDICTION_TREE: {
      const { countryCode: cc, data } = action.payload
      return {
        ...state,
        jurisdictionTrees: { ...state.jurisdictionTrees, [cc]: data },
      };
    }

    case SET_SEARCH_MODE:
      return {
        ...state,
        searchMode: action.payload,
      };

    default:
      return state;
  }
};

export default userReducer;
